import { MutationTree } from 'vuex'
import { IFilterState } from '@/store/filter'
import { Types, Doctor, Appointment, User, Admission, Schedule, Company } from '@/store/filter/types'

const mutations: MutationTree<IFilterState> = {
  [Types.doctor]: (state, action: Doctor) => {
    state.doctor = action.payload
  },
  [Types.appointment]: (state, action: Appointment) => {
    state.appointment = action.payload
  },
  [Types.user]: (state, action: User) => {
    state.user = action.payload
  },
  [Types.admission]: (state, action: Admission) => {
    state.admission = action.payload
  },
  [Types.schedule]: (state, action: Schedule) => {
    state.schedule = action.payload
  },
  [Types.company]: (state, action: Company) => {
    state.company = action.payload
  }
}

export default mutations
